import useCurrentUser from "@v2/hooks/useCurrentUser";
import { useModal } from "@v2/store/modalStore";
import {
  nextJSProjectRouter,
  nextJSProjectUtils,
} from "@v2/trpc/routes/nextJSProject";
import { projectRouter } from "@v2/trpc/routes/project";
import { routes } from "@v2/utils/router";
import { generatePath, useNavigate } from "react-router-dom";

const cleanupPendingTemplate = () => {
  sessionStorage.removeItem("replo_pending_template_id");
};

export function useApplySharedTemplateAfterAuth() {
  const { openModal, modals } = useModal();
  const navigate = useNavigate();
  const { isAuthenticated, isLoading: isLoadingUser } = useCurrentUser();

  const { data: userProjects } = projectRouter.listWithIdAndType.useQuery(
    { hostingType: "replo" },
    {
      // Note (Ezra, 2025-11-18): Cache for 5 minutes since this hook runs frequently during navigation.
      // The data only matters for determining if user has 1 vs multiple v2 projects - if they already
      // have multiple, the behavior is the same if they add more, so stale data is acceptable.
      staleTime: 5 * 60 * 1000,
    },
  );

  const { mutate: createPageFromTemplate, isPending: isCreatingPage } =
    nextJSProjectRouter.createPageFromTemplate.useMutation({
      onSuccess: (data, variables) => {
        void nextJSProjectUtils.listPages.invalidate({
          projectId: variables.projectId,
        });
        cleanupPendingTemplate();
        const chatPath = generatePath(routes.shops.chat, {
          projectId: variables.projectId,
        });
        navigate(`${chatPath}?pageId=${data.createdFile.id}`);
      },
    });

  if (
    !isLoadingUser &&
    isAuthenticated &&
    userProjects?.projects &&
    !modals.selectProjectForTemplateModal &&
    !isCreatingPage
  ) {
    const pageTemplateId = sessionStorage.getItem("replo_pending_template_id");
    if (pageTemplateId) {
      if (userProjects.projects.length === 1 && userProjects.projects[0]) {
        createPageFromTemplate({
          projectId: userProjects.projects[0].id,
          templateId: pageTemplateId,
        });
      } else {
        // Note (Ezra, 2025-11-25): Opens modal for both 0 and >1 projects.
        // 0 projects case: modal will show create shop form or Shopify billing error
        // >1 projects case: modal will show project selection UI
        openModal({
          type: "selectProjectForTemplateModal",
          props: { pageTemplateId },
        });
      }
    }
  }
}
